var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_c('h1',[_vm._v("Page Not Found")]),_c('h2',[_vm._v("The page you're trying to access doesn't exist")]),_c('router-link',{attrs:{"to":"/docs"}},[_c('Button',{staticClass:"btn",attrs:{"btn_name":"Go to Docs >"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }